import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpBackend } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpBackend: HttpBackend) {

  const baseUrl = window.location.origin;
  return new MultiTranslateHttpLoader(httpBackend, [
    { prefix: baseUrl + "/assets/lang/team-snapshot/", suffix: ".json" },
  ]);
}
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
  ],
  exports: [
    TranslateModule
  ]
})
export class LangTranslateModule { }
